import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconUpload = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m11.298 3.304-3.76 3.9a.6.6 0 00-.013.817l.563.623a.6.6 0 00.876.013L11 6.546v9.816a.6.6 0 00.6.601h.8a.6.6 0 00.6-.601V6.535l2.025 2.1a.6.6 0 00.85.016l.017-.018.577-.606a.597.597 0 00-.003-.829l-3.754-3.894a.975.975 0 00-1.414 0ZM5.6 18.962a.6.6 0 00-.6.6v.8a.6.6 0 00.6.6h12.8a.6.6 0 00.6-.6v-.8a.6.6 0 00-.6-.6H5.6Z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconUpload.displayName = "IconUpload";
